<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="23" height="23" rx="2.5" stroke="#000000"/>
    <path d="M7.00006 12.5C8.00006 7.5 20.0001 4 20.0001 4C20.0001 4 15.5001 16.5 11.5001 17M7.00006 12.5L11.5001 17M7.00006 12.5L6 15L9 18L11.5001 17" stroke="#000000"  stroke-linejoin="round"/>
    <path d="M15 5.99997L18 8.99997" stroke="#000000" />
    <circle cx="14" cy="10" r="1" fill="#000" />
    <path d="M7 12C5.4 10.4 3.66667 10.6666 3 11C4.33333 9.66665 8 8.49998 9.5 8.99998" stroke="#000000" />
    <path d="M11.6768 16.8158C13.2768 18.4158 13.0708 20.0383 12.7375 20.7049C14.0708 19.3716 15.3588 15.841 14.8588 14.341" stroke="#000000" />
    <path d="M6.72706 17.5229C7.57559 18.3715 5.6664 19.2907 4.60574 19.6443C4.95929 18.5836 5.87853 16.6744 6.72706 17.5229Z" stroke="#000000" />
  </svg>
</template>
<script>
import Vue from 'vue';

const IconStartups = Vue.extend({
  name: 'icon-startups',
  props: {
    color: {
      type: String,
      default: '#000',
    },
  },
  computed: {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    style() {
      return `stroke: ${this.color};`;
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    fill() {
      return `fill: ${this.color};`;
    },
  },
});
export default IconStartups;
</script>

<style scoped lang="scss">
  /* stylelint-disable */
  .a,
  .b {
    fill: none;
    stroke: #000;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 0.7px;
  }

  .b {
    stroke-miterlimit: 10;
  }
</style>
